<template>
  <div class="qa">
    <div class="home2-title">常见问题</div>
    <div class="qa-content">
      <div class="qa-card" v-for="(item, index) of list" :key="index">
        <h3>
          {{ item.title }}
        </h3>
        <p>
          {{ item.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "如何成为培训学员？",
          content:
            "联系您所在的企业或在官网的报名信息填写资料，进行对应培训方向的课程报名，则可成为该培训班学员",
        },
        {
          title: "如何成为合作企业？",
          content:
            "拨打网站底部联系我们的电话与工作人员沟通后，可与我们合作并成为我们的合作企业",
        },
        {
          title: "如何进行培训和练习？",
          content:
            "登录后可在公共课程库，学习中心和练习中心进行培训看课和考试练习",
        },
        {
          title: "如何进行信息查询？",
          content:
            "在首页快捷服务板块，点击进入各大查询页面，进行对应信息查询或进入快捷服务页面进行查询",
        },
      ],
    };
  },
};
</script>

<style lang="less"  src="./public.less" scoped></style>
<style lang="less" scoped>
.qa {
  width: 1200px;
  margin: 20px auto 50px;
  padding: 0 21px;
  box-sizing: border-box;
  background: #fff;
  .home2-title {
    background-image: url("../../../../static/home2.0/icon-qa.png");
  }
  .qa-content {
    display: flex;
    justify-content: space-between;
    .qa-card {
      width: 25%;
      position: relative;
      padding: 41px 18px 24px 30px;
      box-sizing: border-box;
      &:not(:last-child):after {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -55px;
        width: 1px;
        height: 110px;
        background: #e8e8e8;
      }
      h3 {
        position: relative;
        font-size: 20px;
        color: #333;
        font-weight: bold;
        padding-left: 35px;
        box-sizing: border-box;
        &:before {
          content: "Q";
          display: block;
          position: absolute;
          left: 0;
          top: 5px;
          width: 21px;
          height: 22px;
          background: #ffa234;
          color: #fff;
          font-size: 18px;
          line-height: 22px;
          text-align: center;
          font-weight: normal;
        }
      }
      p {
        position: relative;
        font-size: 14px;
        line-height: 1.6;
        color: #333;
        padding-left: 35px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-top: 33px;
        &:before {
          content: "A";
          display: block;
          position: absolute;
          left: 0;
          top: 5px;
          width: 21px;
          height: 22px;
          background: #3482FF;
          color: #fff;
          font-size: 18px;
          line-height: 22px;
          text-align: center;
          font-weight: normal;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/Qa.vue